import { UMR } from '../../urbanmap/_components';

/**
 * Plan identity on top of the UrbanMap reference tokens (UMR).
 * Plan reuses the UM chrome but carries its own accent so the user always knows
 * they work on a project copy, not on live UrbanMap data.
 */
export const PLAN = {
  accent: 'var(--nj-core-color-teal-700, #00726d)',
  accentStrong: 'var(--nj-core-color-teal-800, #005a56)',
  accentBg: 'var(--nj-core-color-teal-100, #e3f4f2)',
  accentBorder: 'var(--nj-core-color-teal-300, #8fd3cc)',
  warningBg: 'var(--nj-core-color-orange-100, #fdf0e7)',
  warningBorder: 'var(--nj-core-color-orange-300, #f3b58c)',
  warningText: 'var(--nj-core-color-orange-800, #8a3c14)',
  successBg: 'var(--nj-core-color-green-100, #e6f5ea)',
  successText: 'var(--nj-core-color-green-800, #1b6b30)',
  headerHeight: 52,
  /** Map dataset colours (hex allowed for map paint). */
  map: {
    perimeter: '#00726d',
    road: '#8a99a6',
    modified: '#ef6b26',
    scenario: '#7a3fd1',
    scenarioBuilding: '#7a3fd1',
    zone: '#009de9',
    outside: '#ccd4da',
    pipeThirdParty: '#7c8a96',
    delivery: '#005aa0',
    drift: '#bc5921',
    halo: '#ffffff',
  },
} as const;

export { UMR };

export const STATUS_LABEL: Record<string, string> = {
  draft: 'Brouillon',
  running: 'Calcul en cours',
  done: 'Terminé',
  stale: 'À relancer',
};
